import { render, staticRenderFns } from "./FWidget.vue?vue&type=template&id=1c4da22c&scoped=true"
import script from "./FWidget.vue?vue&type=script&lang=js"
export * from "./FWidget.vue?vue&type=script&lang=js"
import style0 from "./FWidget.vue?vue&type=style&index=0&id=1c4da22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4da22c",
  null
  
)

export default component.exports